import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtTL } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileDown, FileSpreadsheet, Wallet, Loader2 } from "lucide-react";

const dl = async (url, filename) => {
  try {
    const res = await api.get(url, { responseType: "blob" });
    const href = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement("a");
    a.href = href; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(href);
  } catch (e) { toast.error("İndirilemedi"); }
};

export default function MyPayslips() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/accounting/payroll/my-payslips").then((r) => setD(r.data)).catch(() => setD({ linked: false, items: [] }));
  }, []);
  return (
    <div className="fade-in mx-auto max-w-3xl space-y-4" data-testid="my-payslips-page">
      <div>
        <h1 className="font-heading text-2xl text-slate-800">Bordrom · Maaş Pusulalarım</h1>
        <p className="text-sm text-slate-500">İşlenmiş maaş pusulalarınızı görüntüleyin ve PDF/Excel indirin.</p>
      </div>
      {!d && <div className="py-16 text-center text-slate-400"><Loader2 className="mx-auto h-6 w-6 animate-spin" /></div>}
      {d && !d.linked && (
        <div className="rounded-md bg-white p-8 text-center ring-1 ring-inset ring-slate-200" data-testid="my-payslips-unlinked">
          <Wallet className="mx-auto mb-2 h-8 w-8 text-slate-300" />
          <p className="text-sm text-slate-500">Hesabınıza bağlı bir personel kaydı bulunamadı. Yöneticinizden personel kartınıza giriş e-posta adresinizin eklenmesini isteyin.</p>
        </div>
      )}
      {d && d.linked && (
        <div className="overflow-hidden rounded-md bg-white ring-1 ring-inset ring-slate-200">
          <div className="border-b border-slate-100 bg-slate-50 px-4 py-3">
            <p className="font-semibold text-slate-700">{d.personnel?.name}</p>
            <p className="text-xs text-slate-500">{d.personnel?.title || ""}</p>
          </div>
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-slate-500"><tr><th className="px-4 py-2">Dönem</th><th className="px-4 py-2 text-right">Net</th><th className="px-4 py-2 text-right">Ele Geçen</th><th className="px-4 py-2 text-right">İndir</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {d.items.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-400">Henüz işlenmiş maaş pusulanız yok.</td></tr>}
              {d.items.map((it) => (
                <tr key={it.period} data-testid={`my-payslip-${it.period}`} className="hover:bg-slate-50">
                  <td className="px-4 py-2 font-medium text-slate-700">{it.period_label}</td>
                  <td className="px-4 py-2 text-right tabular text-emerald-600">{fmtTL(it.net)}</td>
                  <td className="px-4 py-2 text-right tabular text-emerald-700">{fmtTL(it.take_home)}</td>
                  <td className="px-4 py-2 text-right">
                    <div className="flex justify-end gap-1.5">
                      <Button size="sm" variant="outline" data-testid={`my-payslip-pdf-${it.period}`} onClick={() => dl(`/accounting/payroll/my-payslip/export?period=${it.period}&format=pdf`, `maas-pusulasi_${it.period}.pdf`)}><FileDown className="h-4 w-4" /></Button>
                      <Button size="sm" variant="outline" data-testid={`my-payslip-xlsx-${it.period}`} onClick={() => dl(`/accounting/payroll/my-payslip/export?period=${it.period}&format=xlsx`, `maas-pusulasi_${it.period}.xlsx`)}><FileSpreadsheet className="h-4 w-4" /></Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
